export default "__VITE_ASSET__DGDuoGnW__"